import {
	GuardedType,
	isArray,
	IsInterface,
	isBoolean,
	isString,
	isSingletonStringUnion,
	hasStringIndexSignature,
	isNullable
} from "generic-type-guard";

export const isEnumValue = new IsInterface().withProperties({ value: isString, label: isNullable(isString) }).get();
export const isEnumArray = isArray(isEnumValue);
export type EnumValue = GuardedType<typeof isEnumValue>;
export const isEmpfaengerType = isSingletonStringUnion("AN", "CC", "BCC");
export type EmpfaengerTyp = GuardedType<typeof isEmpfaengerType>;
export const isEnumGroup = new IsInterface()
	.withProperties({
		key: isString,
		name: isNullable(isString),
		values: isEnumArray,
		resolved: isBoolean
	})
	.get();
export const isEnumGroupArray = isArray(isEnumGroup);
export type EnumGroup = GuardedType<typeof isEnumGroup>;

const isStringToEnumArrayRecord = hasStringIndexSignature(isEnumArray);
const isStringToStringRecord = hasStringIndexSignature(isString);

export const isContactData = new IsInterface()
	.withProperty(
		"values",
		(v): v is Record<string, EnumValue[]> => typeof v === "object" && v !== null && isStringToEnumArrayRecord(v)
	)
	.withProperty(
		"names",
		(v): v is Record<string, string> => typeof v === "object" && v !== null && isStringToStringRecord(v)
	)
	.get();
export type ContactData = GuardedType<typeof isContactData>;

export const isContactSelectionData = new IsInterface()
	.withProperties({ enumGroups: isEnumGroupArray, empfaengerTyp: isEmpfaengerType })
	.get();
export type ContactSelectionData = GuardedType<typeof isContactSelectionData>;

export const isEmpfaengerEntry = new IsInterface().withProperties({ empfaenger: isString }).get();
export const isEmpfaengerArray = isArray(isEmpfaengerEntry);
export type EmpfaengerEntry = GuardedType<typeof isEmpfaengerEntry>;
